var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from '@apollo/client';
import { useSafeRunMutation } from 'utils/mutations';
var mutation = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation ImpactReportDeleteAttachment($id: ID!) {\n    impactReportDeleteAttachment(id: $id) {\n      id\n      source_attachments {\n        id\n        short_url\n        file_url\n        scan_status\n        title\n        notes\n      }\n    }\n  }\n"], ["\n  mutation ImpactReportDeleteAttachment($id: ID!) {\n    impactReportDeleteAttachment(id: $id) {\n      id\n      source_attachments {\n        id\n        short_url\n        file_url\n        scan_status\n        title\n        notes\n      }\n    }\n  }\n"])));
export default function useImpactReportDeleteAttachment() {
    var _a = useSafeRunMutation({
        mutation: mutation,
        responsePath: 'impactReportDeleteAttachment',
        successMessage: 'Attachment deleted'
    }), onImpactReportDeleteAttachment = _a.onMutate, loading = _a.loading;
    return { onImpactReportDeleteAttachment: onImpactReportDeleteAttachment, loading: loading };
}
var templateObject_1;
